import { render, staticRenderFns } from "./SetupTheChannel.vue?vue&type=template&id=387d1ea4&scoped=true"
import script from "./SetupTheChannel.vue?vue&type=script&lang=js"
export * from "./SetupTheChannel.vue?vue&type=script&lang=js"
import style0 from "./SetupTheChannel.vue?vue&type=style&index=0&id=387d1ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d1ea4",
  null
  
)

export default component.exports